module.exports = __webpack_public_path__ + "static/media/your_post.954d8953.svg";